export default __webpack_public_path__ + "static/media/HM.c041551e.png";